import { usePermissions } from "@/hooks/usePermissions";
import { ShieldAlert } from "lucide-react";

interface Props {
  anyOf: string[];
  children: React.ReactNode;
}

export const RequirePermission: React.FC<Props> = ({ anyOf, children }) => {
  const { data: perms, isLoading, isAdmin } = usePermissions();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (isAdmin) return <>{children}</>;

  const hasAccess = perms?.some((p) => anyOf.includes(p));

  if (!hasAccess) {
    return (
      <div className="flex flex-col items-center justify-center h-64 gap-3 text-muted-foreground">
        <ShieldAlert className="h-12 w-12" />
        <p className="text-lg font-medium">Access Denied</p>
        <p className="text-sm">You do not have the required permissions to view this page.</p>
      </div>
    );
  }

  return <>{children}</>;
};
